// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
__webpack_require__.O(undefined, ["css/app-lp","css/app-admin"], () => (__webpack_require__("./resources/js/app-lp.js")))
__webpack_require__.O(undefined, ["css/app-lp","css/app-admin"], () => (__webpack_require__("./resources/css/app-lp.css")))
var __webpack_exports__ = __webpack_require__.O(undefined, ["css/app-lp","css/app-admin"], () => (__webpack_require__("./resources/css/app-admin.css")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
